var React = require('react');

function ExclamationCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 1c3.85 0 7 3.15 7 7s-3.15 7-7 7-7-3.15-7-7 3.15-7 7-7zm.5 11.5c.275 0 .5-.225.5-.5v-1c0-.275-.225-.5-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1zm.065-3c.268 0 .52-.249.507-.5l.175-5c.032-.299-.203-.5-.472-.5h-1.55a.48.48 0 0 0-.475.5l.148 5c.008.275.235.5.504.5h1.163z"}));
}

ExclamationCircle.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = ExclamationCircle;

ExclamationCircle.default = ExclamationCircle;
